export default __webpack_public_path__ + "static/media/PTT.f7b3d195.jpg";